/*!
 * Flewd LP tracking — GA4 + dataLayer instrumentation for the Magnesium Gap landing pages.
 * Owner: Viktor. Built 2026-08-05. No dependencies. Safe to load on any LP.
 *
 * Reads its config from its own <script> tag:
 *   <script src="lp-tracking.js" defer
 *           data-lp-id="lp1"
 *           data-lp-name="Quiz"
 *           data-cta-selector=".lp1-atf__cta, .lp1-bundle__cta-btn"></script>
 *
 * Emits (each event carries the base params below):
 *   lp_view, lp_scroll, lp_section_view, lp_cta_click, lp_add_to_cart,
 *   lp_checkout_click, lp_email_signup,
 *   lp_quiz_start, lp_quiz_answer, lp_quiz_complete
 * Base params: lp_id, lp_name, lp_slug, lp_variant, lp_traffic, lp_campaign,
 *              lp_content, lp_term, lp_device
 */
(function () {
  'use strict';

  var GA4_ID = 'G-8RL9XNZ9LT';
  var DEBUG = /[?&]lp_debug=1/.test(location.search);

  // Guard against double-inclusion (e.g. section rendered twice in the editor).
  if (window.__flewdLPTracking) { return; }
  window.__flewdLPTracking = true;

  // ---------------------------------------------------------------- config
  var tag = document.currentScript || document.querySelector('script[data-lp-id]');
  var cfg = {
    lpId:  (tag && tag.getAttribute('data-lp-id'))  || 'unknown',
    lpName:(tag && tag.getAttribute('data-lp-name'))|| '',
    ctaSelector: (tag && tag.getAttribute('data-cta-selector')) ||
      '[class*="__cta"], [class*="-cta"], [class*="-buy"], a[href*="/cart"]'
  };

  function log() { if (DEBUG && window.console) console.log.apply(console, ['[lp-tracking]'].concat([].slice.call(arguments))); }

  // ---------------------------------------------------------------- gtag bootstrap
  // GA4 reaches this store through GTM (GTM-W5DCKTH2). Loading gtag.js for the same
  // measurement ID with send_page_view:false is idempotent — it never double-counts
  // page views, and it guarantees our custom events land in GA4 even if the GTM
  // container has no matching custom-event triggers.
  window.dataLayer = window.dataLayer || [];
  // GA4 on this store is loaded by GTM (GTM-W5DCKTH2) with a server-side transport.
  // If gtag already exists we reuse it and send events WITHOUT send_to, so they go to
  // every configured GA4 destination (verified: 2 collect hits per event). Using
  // send_to with the raw measurement ID silently drops events, because the loaded
  // destination IDs are rewritten server-side.
  if (typeof window.gtag !== 'function') {
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA4_ID;
    document.head.appendChild(s);
    window.gtag('config', GA4_ID, { send_page_view: false });
  }

  // ---------------------------------------------------------------- base params
  var qs = new URLSearchParams(location.search);
  function param(n) { return (qs.get(n) || '').slice(0, 100); }

  var slug = (location.pathname.split('/').filter(Boolean).pop() || '').toLowerCase();

  function trafficSource() {
    var src = param('utm_source').toLowerCase();
    var med = param('utm_medium').toLowerCase();
    if (src) {
      if (/google/.test(src)) return 'google_paid';
      if (/(facebook|instagram|meta|fb|ig)/.test(src)) return 'meta_paid';
      if (/klaviyo|email/.test(src) || /email/.test(med)) return 'email';
      return src;
    }
    if (qs.get('gclid') || qs.get('gbraid') || qs.get('wbraid')) return 'google_paid';
    if (qs.get('fbclid')) return 'meta_paid';
    if (qs.get('ttclid')) return 'tiktok';
    var ref = document.referrer || '';
    if (!ref) return 'direct';
    if (/google\./.test(ref)) return 'google_organic';
    if (/(facebook|instagram)\./.test(ref)) return 'meta_organic';
    return 'referral';
  }

  function device() {
    var w = window.innerWidth || 1200;
    return w <= 600 ? 'mobile' : (w <= 1024 ? 'tablet' : 'desktop');
  }

  var base = {
    lp_id: cfg.lpId,
    lp_name: cfg.lpName,
    lp_slug: slug,
    // The Google-paid duplicates of LP1/LP2 end in "-stress".
    lp_variant: /-stress$/.test(slug) ? 'stress' : 'core',
    lp_traffic: trafficSource(),
    lp_campaign: param('utm_campaign'),
    lp_content: param('utm_content'),
    lp_term: param('utm_term'),
    lp_device: device()
  };

  // Persist LP context for the rest of the session so cart/checkout steps that
  // happen on other URLs can still be attributed back to the landing page.
  try {
    sessionStorage.setItem('flewd_lp_ctx', JSON.stringify({
      lp_id: base.lp_id, lp_slug: base.lp_slug,
      lp_variant: base.lp_variant, lp_traffic: base.lp_traffic, t: Date.now()
    }));
  } catch (e) {}

  function send(name, params) {
    var p = {};
    for (var k in base) if (base.hasOwnProperty(k) && base[k] !== '') p[k] = base[k];
    if (params) for (var j in params) if (params.hasOwnProperty(j) && params[j] !== undefined && params[j] !== '') p[j] = params[j];
    try { window.gtag('event', name, p); } catch (e) {}
    var dl = { event: name };
    for (var m in p) if (p.hasOwnProperty(m) && m !== 'send_to') dl[m] = p[m];
    try { window.dataLayer.push(dl); } catch (e) {}
    log(name, p);
  }
  window.flewdLPEvent = send; // exposed so section code can add its own events

  // ---------------------------------------------------------------- helpers
  function sectionNameOf(el) {
    var sec = el && el.closest ? el.closest('section, [id]') : null;
    while (sec && !sec.id && sec.tagName !== 'SECTION') sec = sec.parentElement;
    if (!sec) return '';
    if (sec.id) return sec.id;
    var c = (sec.className || '').toString().split(/\s+/)[0];
    return c || '';
  }
  function labelOf(el) {
    var t = (el.getAttribute('aria-label') || el.textContent || '').replace(/\s+/g, ' ').trim();
    return t.slice(0, 60);
  }
  function idOf(el) {
    if (el.id) return el.id;
    var cls = (el.className || '').toString().split(/\s+/).filter(function (c) { return /^lp/.test(c); });
    return cls[0] || el.tagName.toLowerCase();
  }

  // ---------------------------------------------------------------- lp_view
  send('lp_view', { page_location: location.href.slice(0, 400) });

  // ---------------------------------------------------------------- scroll depth
  (function () {
    var marks = [25, 50, 75, 90, 100], hit = {}, queued = false;
    function measure() {
      queued = false;
      var doc = document.documentElement;
      var scrollable = Math.max(doc.scrollHeight - window.innerHeight, 1);
      var pct = Math.min(100, Math.round((window.pageYOffset / scrollable) * 100));
      for (var i = 0; i < marks.length; i++) {
        if (pct >= marks[i] && !hit[marks[i]]) {
          hit[marks[i]] = true;
          send('lp_scroll', { percent_scrolled: marks[i] });
        }
      }
    }
    window.addEventListener('scroll', function () {
      if (!queued) { queued = true; requestAnimationFrame(measure); }
    }, { passive: true });
    measure();
  })();

  // ---------------------------------------------------------------- section views
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var seen = {};
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var name = en.target.id || (en.target.className || '').toString().split(/\s+/)[0];
        if (!name || seen[name]) return;
        seen[name] = true;
        send('lp_section_view', { lp_section: name, section_index: order.indexOf(en.target) + 1 });
        obs.unobserve(en.target);
      });
    }, { threshold: 0.5 });
    var order = [].slice.call(document.querySelectorAll('section[id], section[class^="lp"]'));
    order.forEach(function (el) { obs.observe(el); });
    log('observing sections', order.length);
  })();

  // ---------------------------------------------------------------- CTA clicks
  var lastCta = '';
  var lastAtc = 0;
  function sendAtc(params) {
    // LP2/LP3 CTAs are cart permalinks that JS upgrades to an AJAX add — dedupe so
    // one user action produces exactly one lp_add_to_cart.
    var now = Date.now();
    if (now - lastAtc < 2500) { return; }
    lastAtc = now;
    send('lp_add_to_cart', params);
  }
  var CHECKOUT_SEL = 'a[href*="/checkout"], [class*="checkout"], [name="checkout"],' +
    ' button[form*="cart"], [data-testid*="checkout"], [href*="/cart/checkout"]';
  function looksLikeCheckout(el) {
    if (!el || el.nodeType !== 1) return null;
    if (matches(el, CHECKOUT_SEL)) return matches(el, CHECKOUT_SEL);
    var tag = (el.tagName || '').toLowerCase();
    if (tag !== 'button' && tag !== 'a' && el.getAttribute && el.getAttribute('role') !== 'button') return null;
    var txt = (el.textContent || '').trim().toLowerCase();
    if (!txt || txt.length > 40) return null;
    // "checkout", "check out", "continue to checkout", "secure checkout"
    return /check\s?out/.test(txt) ? el : null;
  }
  function findCheckout(e, target) {
    var path = (e && typeof e.composedPath === 'function') ? e.composedPath() : [target];
    for (var i = 0; i < path.length; i++) {
      var hit = looksLikeCheckout(path[i]);
      if (hit) return hit;
    }
    return null;
  }
  function matches(el, selector) {
    try { return el.closest(selector); } catch (e) { return null; }
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && /\/(checkout|cart)/.test(f.action) && (f.getAttribute('action') || '').indexOf('checkout') > -1) {
      send('lp_checkout_click', { cta_id: 'cart_form_submit' });
    }
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // Checkout. The slide cart is a web component, so the click target can be inside a
    // shadow root where closest() from e.target sees nothing -- walk composedPath() too.
    // Match on href, class, button name, form action AND visible label, because the
    // Rebuy/slide-cart button carries none of the obvious hooks.
    var co = findCheckout(e, t);
    if (co) { send('lp_checkout_click', { cta_id: idOf(co), lp_section: sectionNameOf(co) }); }

    // Cart permalink / add-to-cart link (counts as an ATC intent)
    var cartLink = t.closest('a[href*="/cart/"]');
    if (cartLink) {
      var m = (cartLink.getAttribute('href') || '').match(/\/cart\/(\d+):(\d+)/);
      lastCta = idOf(cartLink);
      sendAtc({
        atc_source: lastCta,
        lp_section: sectionNameOf(cartLink),
        variant_id: m ? m[1] : '',
        atc_method: 'cart_permalink',
        selling_plan_id: cartLink.getAttribute('data-selling-plan-id') || ''
      });
    }

    // Generic CTA
    var cta = matches(t, cfg.ctaSelector);
    if (cta) {
      lastCta = idOf(cta);
      send('lp_cta_click', {
        cta_id: lastCta,
        cta_text: labelOf(cta),
        lp_section: sectionNameOf(cta),
        cta_href: (cta.getAttribute('href') || '').slice(0, 120)
      });
    }
  }, true);

  // ---------------------------------------------------------------- add to cart (AJAX)
  (function () {
    if (!window.fetch) return;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var isAdd = /\/cart\/add(\.js)?/.test(url);
      var p = orig.apply(this, arguments);
      if (isAdd) {
        p.then(function (res) {
          if (!res || !res.ok) return;
          var variant = '', plan = '', qty = '';
          try {
            var body = init && init.body;
            if (typeof body === 'string') {
              var parsed = JSON.parse(body);
              variant = (parsed.items && parsed.items[0] && parsed.items[0].id) || parsed.id || '';
              plan = (parsed.items && parsed.items[0] && parsed.items[0].selling_plan) || parsed.selling_plan || '';
              qty = (parsed.items && parsed.items[0] && parsed.items[0].quantity) || parsed.quantity || '';
            }
          } catch (e) {}
          sendAtc({
            atc_source: lastCta || 'ajax',
            variant_id: String(variant || ''),
            selling_plan_id: String(plan || ''),
            quantity: String(qty || ''),
            atc_method: 'ajax'
          });
        }).catch(function () {});
      }
      return p;
    };
  })();

  // ---------------------------------------------------------------- email capture
  // Passive listeners only — we never modify the pop-up (externally owned).
  document.addEventListener('klaviyoForms', function (e) {
    if (!e || !e.detail) return;
    if (e.detail.type === 'submit') {
      send('lp_email_signup', { signup_source: 'klaviyo_form', form_id: String(e.detail.formId || '') });
    }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var act = (f.getAttribute('action') || '') + ' ' + (f.className || '');
    if (/klaviyo|contact#|newsletter|customer/i.test(act) && f.querySelector('input[type="email"]')) {
      send('lp_email_signup', { signup_source: 'form', lp_section: sectionNameOf(f) });
    }
  }, true);

  // ---------------------------------------------------------------- quiz (LP1)
  (function () {
    var chips = document.querySelectorAll('[class*="quiz__chip"]');
    if (!chips.length) return;
    var slides = [].slice.call(document.querySelectorAll('[data-slide]'));
    var totalSlides = slides.reduce(function (mx, el) {
      return Math.max(mx, parseInt(el.getAttribute('data-slide'), 10) || 0);
    }, 0);
    var started = false, completed = false, maxStep = 0;

    function stepOf(el) {
      var s = el.closest ? el.closest('[data-slide]') : null;
      return s ? (parseInt(s.getAttribute('data-slide'), 10) || 0) : 0;
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var chip = t.closest('[class*="quiz__chip"]');
      if (chip) {
        var step = stepOf(chip);
        if (!started) { started = true; send('lp_quiz_start', { quiz_steps_total: totalSlides }); }
        if (step > maxStep) maxStep = step;
        send('lp_quiz_answer', {
          quiz_step: step,
          quiz_answer: chip.getAttribute('data-value') || labelOf(chip),
          quiz_answer_text: labelOf(chip)
        });
        return;
      }

      var next = t.closest('[class*="quiz__next"], [data-action="next"]');
      if (next) {
        var s2 = stepOf(next);
        send('lp_quiz_next', { quiz_step: s2 });
        if (!completed && totalSlides && s2 >= totalSlides) {
          completed = true;
          send('lp_quiz_complete', { quiz_steps_total: totalSlides });
        }
      }
    }, true);

    // Fallback completion signal: the results/bundle slot getting populated.
    var slot = document.querySelector('[class*="quiz__bundle-slot"]');
    if (slot && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (completed) return;
        if (slot.children.length || (slot.textContent || '').trim()) {
          completed = true;
          send('lp_quiz_complete', { quiz_steps_total: totalSlides, completion_signal: 'results_rendered' });
        }
      }).observe(slot, { childList: true, subtree: true });
    }
  })();

  log('initialised', base);
})();
